module.exports = __webpack_public_path__ + "static/media/lUUnN7VGSoWZ3noefeH7_Baker_Beach-12.292b6983.jpg";